(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('FilesListController', FilesListController)

    /** @ngInject */
    function FilesListController($scope, $q, $window, $rootScope, $state, $stateParams, $timeout, FileService, HelperService, FileFolderService, FileCategoryService, AuthenticationService, ROUTES, DATA_EVENTS, LOCAL_STORAGE_ITEMS) {
        const vm = this;

        let userData;
        let fullUrl = '';

        vm.formatSize = FileService.formatSize;

        vm.downloadFile = file => {
            let accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);

            return FileService
                .verifyDownload(file.Id)
                .then(() => $window.location.href = `${ROUTES.API}/files/download/${userData.Id}/${file.Id}?accessToken=${accessToken}`, error => HelperService.errorCallback(error));
        }

        vm.getFileIcon = file => {
            return HelperService.imageHandlerFileIcon(file.Extension.trim());
        }

        vm.goBackToParentFolder = () => {
            let folder = vm.selectedFolderPath[vm.selectedFolderPath.length - 2];
            vm.selectedFolder = {};

            vm.onFolderSingleClick(folder, false);
        }

        vm.onFolderSingleClick = (folder, isFoward) => {
            if (vm.selectedFolder == folder) return;

            if (vm.isTableSearch)
                fullUrl = folder.UrlFull;
            else if (isFoward) {
                vm.selectedFolderPath.push(folder);

                if (fullUrl != null && fullUrl.length > 1)
                    fullUrl = `${fullUrl}/${folder.Url}`;
                else
                    fullUrl = folder.Url;
            } else {
                let folderIndex = vm.selectedFolderPath.indexOf(folder);
                vm.selectedFolderPath.splice(folderIndex + 1, 9e9);
                isFoward = true;

                fullUrl = vm.selectedFolderPath.reduce((acc, cur) => {
                    if (!cur.Url) return acc;

                    acc = acc + `/${cur.Url}`;

                    return acc;
                }, '');

                fullUrl = fullUrl.substring(1, fullUrl.length);
            }

            $state.go('app-master.default.files-root', {
                folderUrl: fullUrl
            })

            vm.selectedFolder = folder;
            vm.searchText = null;
            vm.isTableSearch = false;

            $timeout(() => {
                vm.navigateToFolder(folder, isFoward);
            })
        }

        vm.navigateToFolder = (folder, isFoward) => {
            let folderId = 0;

            if (isFoward) {
                folderId = folder.Id;
            } else {
                folderId = folder.ParentFileFolderId;
            }

            HelperService.startLoading('.list-container');

            $q.all([getFolderContent(folderId)])
                .then(() => {
                    HelperService.stopLoading('.list-container');
                }, error => {
                    console.log('error: ', error);
                })
        }

        vm.getCurrentFileFolder = () => {
            return vm.selectedFolderPath[vm.selectedFolderPath.length - 1];
        }

        vm.showFileModal = file => {
            vm.selectedFile = file;

            $timeout(() => {
                $('#modalDetailsFile').modal('show');
            });
        }

        vm.getFileThumbnail = file => {
            return HelperService.imageResizePath('file', file.Id, file.Thumbnail, 470, 300);
        }

        vm.isCurrentFolder = folder => {
            return folder.Url == vm.selectedFolderPath[vm.selectedFolderPath.length - 1].Url;
        }

        // SEARCH
        vm.isSearchDisabled = () => {
            if (vm.datePicker.date.startDate || vm.searchText || vm.selectedCategory)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (vm.isTableSearch)
                return false;

            if (vm.datePicker.date.startDate || vm.searchText || vm.selectedCategory)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                vm.selectedFolderPath = [{
                    Id: null,
                    Title: 'Raiz'
                }];

                fullUrl = null;

                $state.go('app-master.default.files-root', {
                    folderUrl: fullUrl
                })

                getFolderContent();
            }
        }

        vm.clearSearch = () => {
            vm.datePicker.date.startDate = null;
            vm.datePicker.date.endDate = null;
            vm.searchText = '';
            vm.selectedCategory = null;

            if (vm.isTableSearch) {
                vm.isTableSearch = false;

                getFolderContent();
            }
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getCategories() {
            FileCategoryService
                .getAll()
                .then(success => {
                    vm.categories = success;

                    getFolderContent();
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getFolderContent(folderId) {
            HelperService.startLoading('.list-container');

            vm.isLoadingContent = true;
            vm.folders = [];
            vm.files = [];

            const parameters = prepareParameters();

            parameters.ResponsibilityId = userData.Responsibility.Id;

            if (vm.selectedFolderPath.length > 1)
                vm.selectedFolderPath = [{
                    Id: null,
                    Title: 'Raiz'
                }];

            return FileFolderService
                .getFolderContent(parameters, userData.Id, folderId, fullUrl)
                .then(success => {
                    vm.folders = success.Folders;
                    vm.files = success.Files;
                    vm.parents = success.ParentFileFolderList;

                    if (fullUrl) {
                        vm.selectedFolder = vm.parents[vm.parents.length - 1];

                        for (let index = 0; index < vm.parents.length; index++)
                            vm.selectedFolderPath.push(vm.parents[index]);
                    }

                    if (!vm.files || !vm.folders || (vm.files && !vm.files.length) || (vm.folders && !vm.folders.length))
                        vm.noResults = true;

                    vm.isLoadingContent = false;

                    HelperService.stopLoading('.list-container');
                }, error => {
                    vm.noResults = false;
                    vm.isLoadingContent = false;
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.list-container');
                })
        }

        function prepareParameters() {
            let params = {
                OrderBy: 'Title',
                OrderDescending: false,
                Active: true
            }

            if (vm.datePicker.date.startDate) {
                params.StartDate = vm.datePicker.date.startDate.format('YYYY-MM-DD');
                params.EndDate = vm.datePicker.date.endDate.format('YYYY-MM-DD');
                vm.isTableSearch = true;
            }

            if (vm.searchText) {
                params.SearchField = 'Title';
                params.SearchQuery = vm.searchText;
                vm.isTableSearch = true;
            }

            if (vm.selectedCategory) {
                params.FileCategoryId = vm.selectedCategory.Id;
                vm.isTableSearch = true;
            }

            if (vm.isTableSearch)
                params.IsSearch = true;

            return params;
        }

        function initVars() {
            userData = AuthenticationService.getUserData();

            if ($stateParams.folderUrl)
                fullUrl = $stateParams.folderUrl;

            vm.isLoadingContent = true;
            vm.isTableSearch = false;
            vm.selectedFolder = {};
            vm.folders = [];
            vm.files = [];

            vm.selectedFolderPath = [{
                Id: null,
                Title: 'Raiz'
            }];

            vm.datePicker = {
                date: {
                    startDate: null,
                    endDate: null
                },
                options: {
                    'opens': 'left',
                    'timePicker': false,
                    'format': 'DD/MM/YYYY',
                    'ranges': {
                        'Amanhã': [
                            moment().add(1, 'days'),
                            moment().add(1, 'days')
                        ],
                        'Hoje': [
                            moment(),
                            moment()
                        ],
                        'Ontem': [
                            moment().subtract(1, 'days'),
                            moment().subtract(1, 'days')
                        ],
                        '7 Dias': [
                            moment().subtract(7, 'days'),
                            moment()
                        ]
                    },
                    'eventHandlers': {
                        'cancel.daterangepicker': (ev, picker) => {
                            vm.datePicker.date = {
                                startDate: null,
                                endDate: null
                            };
                        }
                    }
                }
            }
        }

        function init() {
            initVars();

            HelperService.startLoading('.list-container');

            getCategories();
        }
    }
}());